import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18/i18n'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import VueApexCharts from 'vue-apexcharts'
// export const EventBus = new Vue();


Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  BootstrapVue,
  IconsPlugin,
  VueApexCharts,
  render: h => h(App),
}).$mount('#app')

